export const LOAD_NOTIFICATIONS = 'NOTIFICATIONS/LOAD_NOTIFICATIONS';
export const LOAD_NEW_NOTIFICATIONS = 'NOTIFICATIONS/LOAD_NEW_NOTIFICATIONS';
export const NEW_NOTIFICATIONS_COUNT = 'NOTIFICATIONS/NEW_NOTIFICATIONS_COUNT';
export const STORE_COUNT_NEW_NOTIFICATIONS = 'NOTIFICATIONS/STORE_COUNT_NEW_NOTIFICATIONS';
export const SET_LOADING_NOTIFICATIONS = 'NOTIFICATIONS/SET_LOADING_NOTIFICATIONS';
export const STORE_NOTIFICATIONS = 'NOTIFICATIONS/STORE_NOTIFICATIONS';
export const STORE_NEW_NOTIFICATIONS = 'NOTIFICATIONS/STORE_NEW_NOTIFICATIONS';
